<template>
    <v-btn
        v-show="page.showButton"
        icon
        fab
        outlined
        fixed
        bottom
        right
        color="primary"
        @click="scrollToTop"
    >
        <v-icon>{{ icons.mdiArrowUp }}</v-icon>
    </v-btn>
</template>

<script>
import { reactive, onBeforeUnmount, onMounted } from '@vue/composition-api'

import { mdiArrowUp } from "@mdi/js";

export default {
  name: "BackToTop",
  components: {},
  setup(props, { emit }) {
    const page = reactive({
      showButton: false,
    });

    // =>  METHODS
    const handleScroll = () => {
      // Affiche le bouton si l'utilisateur a défilé de plus de 300px
      page.showButton = window.pageYOffset > 300;
    };

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

    // =>  COMPUTED

    // =>  WATCH

    // =>  HOOKS
    onMounted(() => {
        window.addEventListener("scroll", handleScroll);
    });

    onBeforeUnmount(() => {
        window.removeEventListener("scroll", handleScroll);
    });

    // =>  DATA
    return {
      icons: {
        mdiArrowUp,
      },
      page,
      scrollToTop,
    };
  },
};
</script>
